import { FormInputSearch, PrimaryButton } from '@systemeio/ui'
import { ContactBulkApiInterface } from 'modules/contacts/types/contact-menu-interface'
import { useTagsAll } from 'modules/tags/hooks/use-tags-all'
import React, { useState } from 'react'
import EmptyList from 'shared/components/table/components/empty-list'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { CheckCircleSelectedIcon } from '@systemeio/ui'

interface ContactSelectTagsProps {
  className?: string
  tempTags?: ContactBulkApiInterface[]
  setTempTags: React.Dispatch<React.SetStateAction<ContactBulkApiInterface[] | undefined>>
  resetTags?: () => void
  additionalButtonBarComponent?: React.ReactNode
}
const ContactSelectTags = ({
  className,
  tempTags,
  setTempTags,
  resetTags,
  additionalButtonBarComponent,
}: ContactSelectTagsProps) => {
  const { t } = useLocoTranslation()

  const { tags } = useTagsAll()

  const [search, setSearch] = useState('')

  return (
    <div className={`flex flex-col gap-5 ${className || ''}`}>
      <div className={'flex flex-col items-center justify-between gap-3 lg:flex-row'}>
        <h1 className={'self-start text-[17px] lg:self-center'}>
          {t('dashboard.contact_page.select_tags')}
        </h1>
        <div className={'flex flex-wrap gap-3 self-end'}>
          <FormInputSearch
            onClear={() => setSearch('')}
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
          <PrimaryButton
            disabled={!tags}
            onClick={() => {
              setSearch('')
              resetTags && resetTags()
            }}
          >
            {t('dashboard.contact_page.discard_changes')}
          </PrimaryButton>
          {additionalButtonBarComponent}
        </div>
      </div>
      <ul
        className={
          'customScroll border-text-secondary/30 flex max-h-[400px] flex-wrap gap-[10px] overflow-y-auto rounded-lg border p-[13px]'
        }
      >
        {tags && tempTags ? (
          tags.items.filter(tag => tag.name.toLowerCase().includes(search.toLowerCase())).length ===
          0 ? (
            <EmptyList small />
          ) : (
            tags.items
              .filter(tag => tag.name.toLowerCase().includes(search.toLowerCase()))
              .map(tag => {
                const isSelected = !!tempTags.find(el => el.id === tag.id)
                return (
                  <li
                    key={tag.id}
                    className={`main-transition-colors flex h-fit gap-1.5 rounded-full ${
                      isSelected
                        ? 'bg-text-primary text-background-secondary'
                        : 'bg-background-primary text-text-primary'
                    } w-fit cursor-pointer items-center px-4 py-2`}
                    onClick={() =>
                      setTempTags(
                        prev =>
                          prev &&
                          (isSelected ? prev.filter(el => el.id !== tag.id) : [...prev, tag]),
                      )
                    }
                  >
                    {tag.name}
                    <CheckCircleSelectedIcon
                      className={`main-transition-colors h-[16px] w-[16px] cursor-pointer sm:h-[16px] sm:w-[16px] ${
                        isSelected && 'fill-background-secondary'
                      }`}
                      isSelected={isSelected}
                    />
                  </li>
                )
              })
          )
        ) : (
          <ContactSelectedTagsSkeleton />
        )}
      </ul>
    </div>
  )
}

const ContactSelectedTagsSkeleton = () => (
  <>
    {Array.from(Array(10).keys()).map((el, idx) => (
      <li
        key={idx}
        className={
          'bg-skeleton-primary w-[110px] animate-pulse rounded-full py-1.5 text-transparent'
        }
      >
        .
      </li>
    ))}
  </>
)

export default ContactSelectTags
